export default {
  namespaced: true,
  training: {
    title: "Treinamentos",
    training_topic: "Tema da capacitação",
    number_of_guests: "Número de pessoas convidadas",
    number_of_attendees: "Número de participantes",
    cost: "Custo",
    supplier_name: "Nome do fornecedor",
    add_training: "Adicionar treinamento",
    center: "Centro",
    sector: "Sector",
    region: "Región",
    type: "Tipo",
    mode: "Modalidad",
    confirm_cancel: "¿Estás seguro de que deseas cancelar esta capacitación?",
    canceled: "Capacitación cancelada"
  }
};
